export default __webpack_public_path__ + "static/img/kerstin_siri_working.5718ea9.jpg";